import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b5ed679c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b5ed679c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ed679c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5ed679c')) {
      api.createRecord('b5ed679c', component.options)
    } else {
      api.reload('b5ed679c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b5ed679c&scoped=true", function () {
      api.rerender('b5ed679c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/ImageViewer/index.vue"
export default component.exports